import { useMutation } from '@tanstack/react-query';

import { DeleteTimelineContainerParameters } from '../../../../../../typings/api/skymap/rest/v0/timeline-containers';
import { SkyMapAxiosServiceFactory } from '../../../../services/axios/skymap-axios-service-factory';

type Props = {
  onSuccess?: (containedId: string) => void;
  onError?: (error: Error) => void;
};

const useDeleteProjectTimeline = (props: Props) =>
  useMutation({
    mutationFn: async (params: DeleteTimelineContainerParameters) => {
      const timelineService = SkyMapAxiosServiceFactory.instance.createTimelineServiceV0();
      await timelineService.deleteTimelineContainer(params);
      return params.path.containerId;
    },
    retry: false,
    networkMode: 'always',
    onSuccess: props?.onSuccess,
    onError: props?.onError,
  });

export { useDeleteProjectTimeline };
